import gql from 'graphql-tag';

export default gql`
  mutation setDraftOrderDeliveryDateTime($input: SetDraftOrderDeliveryDateTimeInput!) {
    setDraftOrderDeliveryDateTime(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
